module.exports = __webpack_public_path__ + "img/download.b383bc91.svg";